<div *ngrxLet="viewModel$; let model;">

  <ng-template #mapsIcon>
    <img src="https://storage.googleapis.com/lsc-tmp-images/maps.svg"
         alt height="24" width="24"/>
  </ng-template>


  <ng-container>
    <div class="flex items-center">
      @if (model.params?.data?.mapsUrl) {
        <a href="{{model.params?.data?.mapsUrl}}"
            target="_blank"
            rel="noopener noreferrer"
            matTooltip="Show this location on Google Maps"
            appGtagEvent
            trackOn="click"
            action="open link"
            category="Navigation [overhaul]"
            [params]="{event_label: 'Open location in Google Maps'}">
          <span class="enabledImg">
            <span [ngTemplateOutlet]="mapsIcon"></span>
          </span>
        </a>
      }
      @if (!model.params?.data?.mapsUrl) {
        <span
            class="disabledImg"
            matTooltip="This location is not on Google Maps">
          <span [ngTemplateOutlet]="mapsIcon"></span>
        </span>
      }

      <mat-divider vertical></mat-divider>

      <!-- claim & duplicate action buttons -->
      <app-cc-action-buttons [placeId]="model.params?.data?.placeId"></app-cc-action-buttons>

      <mat-divider vertical></mat-divider>

      <!--star button-->

      <button mat-icon-button
              class="ml-2"
              id="starButton"
              [disabled]="model.menu?.ccLocationsLoading ||
                model.menu?.ccRowSettingsDictionary?.[model.params?.data?.placeId]?.ongoingCcOperation === ccOperations.CHANGE_STARRING"
              [class.text-orange-70]="model.params?.data?.starred"
              (click)="startCcOperation(model.menu?.focusedLocationId, model.menu?.ccRowSettingsDictionary?.[model.params?.data?.placeId], ccOperations.CHANGE_STARRING, !model.params?.data?.starred)">
        @if (!(model.menu?.ccRowSettingsDictionary?.[model.params?.data?.placeId]?.ongoingCcOperation === ccOperations.CHANGE_STARRING ||
            model.menu?.ccLocationsLoading)) {
          <mat-icon [svgIcon]="model.params?.data?.['starred'] ? 'star' : 'star_border'"></mat-icon>
        }

        @if (model.menu?.ccRowSettingsDictionary?.[model.params?.data?.placeId]?.ongoingCcOperation === ccOperations.CHANGE_STARRING) {
          <mat-spinner
              [diameter]="24"></mat-spinner>
        }

        @if (model.menu?.ccLocationsLoading) {
          <ngx-skeleton-loader count="1"
                               [theme]="{ height: '30px', width: '30px', marginTop: '15px' }"
                               animation="pulse"
          ></ngx-skeleton-loader>
        }
      </button>

      <!--map pin -->

      <div class="h-10 w-10 flex items-center justify-center relative"
           (click)="onMarkerSvgClick(marker, model.menu?.isCvOn)"
           *ngrxLet="getMarkerLocation$(model.params?.data); let marker">
        <img [src]="marker?.url && !model.menu?.isCvOn ? getSafeSvgUrl(marker?.url?.default) :
                'assets/images/mapMarkers/default_marker_icon.png'"
             class="h-[33px]"
             [ngClass]="{ 'grayscale': !marker?.url || model.menu?.isCvOn,
                          'opacity-20': !marker?.url || model.menu?.isCvOn,
                          'cursor-pointer': marker?.url && !model.menu?.isCvOn }"
             alt/>
        <span class="markerLabel">{{ marker?.label?.text }}</span>
      </div>
    </div>
  </ng-container>
</div>
